<template>
    <div class="liveStatement-container">
        <div class="liveStatement-title">DTP药房专业化能力建设直播间声明</div>
        <div class="liveStatement-content">
            <div>欢迎来到DTP药房专业化能力建设项目，本项目旨在汇聚医药领城的专业人才，共同探讨医药前沿技术与发展趋势。参与者需持有有效的医药执业证书或相关资质证明。</div>
            <div>为了项目的专业性和安全性，请非医药专业人员考虑其他适合自己的项目，如您并非医药专业人员，同时有相关咨询需求，请联系专业人员。</div>
            <div>我们郑重声明，因任何本项目访问者或任何获知本项目内容者基于对本项目材料的信赖所引起的任何责任与义务，都与本项目无关。您同意DTP药房专业化能力建设直播间内容将不对您使用和/或依赖本项目内容、产品、信息或者资讯导致的直接或间接损失承担任何责任。</div>
        </div>
        <div class="liveStatement-footer">
            <CustomButton
                size="small"
                type="primary"
                class="liveStatement-submit"
                @click="doCommit"
            >
                我是专业医学人士
            </CustomButton>
            <CustomButton
                size="small"
                type="info"
                class="liveStatement-cancel"
                @click="doCancel"
            >
                我不是专业医学人士，退出
            </CustomButton>
        </div>
    </div>
</template>
<script>
import CustomButton from "@/components/unit/CustomButton";
export default {
    name: "liveStatement",
    props: {
      info: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    components: {
        CustomButton
    },
        methods: {
            doCommit() {
                this.$emit("doComfirm");
            },
            doCancel() { 
                this.$emit("doCancel");
            }
        }
}
</script>
<style>
.liveStatement-container{
    background: #fff;
    padding: 0.8rem;
    width: 10.433333rem;
    /* height: 60%; */
    /* width: 91%; */
    z-index: 999;
    font-size:0.45rem;
}
.liveStatement-title{
    width: 100%;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.5rem;
}
.liveStatement-content{
    text-indent: 2em;
    font-size:0.45rem;
    word-break: break-all;
    margin-bottom: 1rem;
}
.liveStatement-footer{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.liveStatement-submit,.liveStatement-cancel{
    font-size:0.45rem;
    height: 1rem;
    border-radius: 5px;
    margin-top: 0.5rem;
}
</style>
